export default function BookingProcess() {
  const steps = [
    {
      number: '01',
      title: 'Choose Your Package',
      description: 'Browse our Umrah or Hajj packages and select the one that best suits your needs and budget'
    },
    {
      number: '02',
      title: 'Speak with Our Advisors',
      description: 'Connect with our travel experts who will guide you through the details and answer all your questions'
    },
    {
      number: '03',
      title: 'Secure Your Booking',
      description: 'Complete your booking with a deposit and receive instant confirmation with all travel documents'
    },
    {
      number: '04',
      title: 'Pre-Departure Preparation',
      description: 'Attend our pre-departure briefing sessions and receive comprehensive travel guidance'
    },
    {
      number: '05',
      title: 'Begin Your Journey',
      description: 'Depart with confidence knowing our team is available 24/7 to support you throughout your pilgrimage'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#C9A961] text-lg mb-4 italic" style={{ fontFamily: 'Playfair Display, serif' }}>
            /Simple & Secure
          </p>
          <h2 className="text-5xl lg:text-6xl font-bold text-[#3A2F2B] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            How to Book
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our straightforward booking process ensures a hassle-free experience from start to finish
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-[#FAF8F5] -translate-y-1/2"></div>
          
          <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-8 relative">
            {steps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="relative mb-6">
                  <div className="w-24 h-24 flex items-center justify-center mx-auto bg-[#FAF8F5] rounded-full relative z-10">
                    <span className="text-3xl font-bold text-[#C9A961]" style={{ fontFamily: 'Playfair Display, serif' }}>
                      {step.number}
                    </span>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-[#1A1F2E] mb-3">{step.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-16">
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="px-10 py-4 bg-[#1A1F2E] text-white rounded-lg text-lg font-semibold hover:bg-[#2A3F4E] transition-all whitespace-nowrap cursor-pointer"
          >
            Start Your Booking
          </button>
        </div>
      </div>
    </section>
  );
}
